<h3 class="title" *ngIf="fileInfoReqired">The following documents will be uploaded</h3>
<div *ngIf="!isEducation">
    <div class="info-block" *ngFor="let textField of info.textFields">
        <p class="info-block__label">{{ textField.label }}</p>
        <p class="info-block__content">{{ textField.text }}</p>
    </div>
    <div class="info -block" *ngIf="fileInfoReqired">
        <p class="info-block__label">Files:</p>
        <p class="info-block__content"><cm-files-list [files]="info.files" [maxSize]="maxSize"></cm-files-list></p>
    </div>
</div>
<div *ngIf="isEducation" class="info-block">
    <p class="info-block__label">Credential(s) name:</p>
    <p class="info-block__content"><cm-files-list [maxSize]="maxSize" [files]="info.files"></cm-files-list></p>
</div>
